import view from './view';
import icon from '@plone/volto/icons/headset.svg';

export default {
  id: 'hp_customer_support',
  title: 'HP Customer Support',
  icon: icon,
  group: 'homepage',
  view: view,
};